import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { format } from 'date-fns';
import DENRLogo from '@/assets/denr-logo.png';
import BagongPilipinasLogo from '@/assets/BAGONG-PILIPINAS-LOGO.png';

export const generatePaymentSlip = async ({
   oop,
   paymentDetails,
   officeDetails
}) => {
   const doc = new jsPDF();

   // Add DENR logo (you'll need to import and convert to base64)
   // doc.addImage(denrLogo, 'PNG', 20, 10, 30, 30);

   // Header
   doc.setFontSize(20);
   doc.text('PAYMENT SLIP', 105, 20, { align: 'center' });
   doc.setFontSize(12);
   doc.text('Department of Environment and Natural Resources', 105, 30, { align: 'center' });
   doc.text('PENRO Marinduque', 105, 35, { align: 'center' });

   // Payment Details
   doc.setFontSize(14);
   doc.text('Payment Details', 20, 50);
   doc.setFontSize(10);
   doc.text(`Bill Number: ${oop.billNo}`, 20, 60);
   doc.text(`Amount Due: ₱${oop.totalAmount.toFixed(2)}`, 20, 70);
   doc.text(`Due Date: ${format(new Date(Date.now() + 3 * 24 * 60 * 60 * 1000), 'MMMM d, yyyy')}`, 20, 80);

   // Payer Information
   doc.setFontSize(14);
   doc.text('Payer Information', 20, 100);
   doc.setFontSize(10);
   doc.text(`Name: ${paymentDetails.fullName}`, 20, 110);
   doc.text(`Email: ${paymentDetails.email}`, 20, 120);
   doc.text(`Phone: ${paymentDetails.phoneNumber}`, 20, 130);
   doc.text(`Address: ${paymentDetails.address}`, 20, 140);

   // Office Information
   doc.setFontSize(14);
   doc.text('Payment Instructions', 20, 160);
   doc.setFontSize(10);
   doc.text(`Address: ${officeDetails.address}`, 20, 170);
   doc.text(`Office Hours: ${officeDetails.officeHours}`, 20, 180);
   doc.text(`Contact: ${officeDetails.contactNumber}`, 20, 190);

   // Important Notes
   doc.setFontSize(12);
   doc.text('Important Notes:', 20, 210);
   doc.setFontSize(10);
   const notes = [
      '• Please bring a valid ID',
      '• Payment must be made within 3 working days',
      '• Keep your official receipt for future reference',
      '• Present this payment slip to the cashier'
   ];
   notes.forEach((note, index) => {
      doc.text(note, 20, 220 + (index * 7));
   });

   // Footer
   doc.setFontSize(8);
   // doc.text('This is a computer-generated document. No signature required.', 105, 280, { align: 'center' });

   return doc.output('blob');
};

export const generateCSAWCertificatePDF = async ({ certificate }) => {
   const doc = new jsPDF();

   // Convert images to base64 first
   const denrLogoBase64 = DENRLogo; // You'll need to import the actual base64 string
   const bpLogoBase64 = BagongPilipinasLogo;

   doc.addImage(denrLogoBase64, 'PNG', 20, 10, 30, 30);
   doc.addImage(bpLogoBase64, 'PNG', 160, 10, 30, 30);

   // Header
   doc.setFontSize(16);
   doc.text('CERTIFICATE OF REGISTRATION', 105, 30, { align: 'center' });
   doc.setFontSize(12);
   doc.text('Department of Environment and Natural Resources', 105, 40, { align: 'center' });
   doc.text('PENRO Marinduque', 105, 45, { align: 'center' });
   doc.text(`No. ${certificate.certificateNumber}`, 105, 55, { align: 'center' });

   // Main content
   doc.setFontSize(10);
   doc.text([
     'After having complied with the provisions of DENR Administrative Order No. 2003-24, Series of 2003',
     'otherwise known as "The Implementing Rules and Regulations of the Chainsaw Act of 2002 (RA No. 9175)"',
     'entitled "AN ACT REGULATING THE OWNERSHIP, POSSESSION, SALE, IMPORTATION AND USE OF CHAINSAWS',
     'PENALIZING VIOLATIONS THEREOF AND FOR OTHER PURPOSES" this Certificate of Registration to own,',
     'possess and/or use a chainsaw is hereby issued to:'
   ], 20, 70);

   // Owner Information
   doc.setFontSize(12);
   doc.text(certificate.certificateData.ownerName, 105, 100, { align: 'center' });
   doc.setFontSize(10);
   doc.text('(Name of Owner)', 105, 105, { align: 'center' });
   doc.text(certificate.certificateData.address, 105, 115, { align: 'center' });
   doc.text('(Address)', 105, 120, { align: 'center' });

   // Chainsaw Details
   doc.text('Bearing the following information and descriptions:', 20, 135);
   doc.text(`Use of the Chainsaw: ${certificate.certificateData.purpose}`, 20, 145);

   const chainsawDetails = [
     [`Brand: ${certificate.certificateData.chainsawDetails.brand}`, `Power Output: ${certificate.certificateData.chainsawDetails.powerOutput}`],
     [`Model: ${certificate.certificateData.chainsawDetails.model}`, `Maximum Length of Guidebar: ${certificate.certificateData.chainsawDetails.maxLengthGuidebar}`],
     [`Serial No: ${certificate.certificateData.chainsawDetails.serialNumber}`, `Country of Origin: ${certificate.certificateData.chainsawDetails.countryOfOrigin}`],
     [`Date of Acquisition: ${format(new Date(certificate.certificateData.chainsawDetails.dateOfAcquisition), 'MMMM d, yyyy')}`, `Purchase Price: ₱${certificate.certificateData.chainsawDetails.purchasePrice.toFixed(2)}`]
   ];

   doc.autoTable({
     startY: 155,
     body: chainsawDetails,
     theme: 'plain',
     styles: { fontSize: 10 },
     columnStyles: { 0: { cellWidth: 85 }, 1: { cellWidth: 85 } }
   });

   // Signature Section
   doc.text('APPROVED BY:', 20, 220);
   doc.text('IMELDA M. DIAZ', 105, 240, { align: 'center' });
   doc.text('OIC-PENR Officer', 105, 245, { align: 'center' });

   // Footer
   doc.text(`Amount paid: Php ${certificate.orderOfPayment?.officialReceipt?.amount?.toFixed(2) || '500.00'}`, 20, 260);
   doc.text(`O.R. No.: ${certificate.orderOfPayment?.officialReceipt?.orNumber || '_______________'}`, 20, 265);
   doc.text(`Date: ${certificate.orderOfPayment?.officialReceipt?.dateIssued ?
     format(new Date(certificate.orderOfPayment.officialReceipt.dateIssued), 'MMMM d, yyyy') :
     '_________________'}`, 20, 270);

   doc.setFontSize(8);
   doc.text('***Not valid w/o PENRO Official Seal***', 105, 280, { align: 'center' });
   doc.text('Capitol Compound, Barangay Bangbangalon, Boac, Marinduque', 105, 285, { align: 'center' });

   return doc.output('blob');
};
